import { Link as RouterLink } from 'react-router';
import { Button } from '../ui/components';
import { env } from '../config/env';
import { useSelector } from 'react-redux';

const cardStyle = { padding: 24, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid var(--ds-border-default)', borderRadius: 'var(--ds-border-radius-large)' };

const HomePage = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 8, color: 'var(--ds-text-primary)' }}>
          Welcome to LoanKnow
        </h1>
        <p style={{ fontSize: '1.1rem', color: 'var(--ds-text-secondary)', marginBottom: 24 }}>
          The world's first consumer-direct mortgage application
        </p>
        <RouterLink to="/readiness" style={{ textDecoration: 'none' }}>
          <Button variant="primary" size="lg">Start Your Application</Button>
        </RouterLink>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, justifyContent: 'center' }}>
        <div style={cardStyle}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: 12, color: 'var(--ds-text-primary)' }}>React Router</h2>
          <p style={{ textAlign: 'center', marginBottom: 16, color: 'var(--ds-text-secondary)' }}>
            Navigate between pages with React Router v7, the latest version of the most popular routing library for React.
          </p>
          <RouterLink to="/about" style={{ textDecoration: 'none', marginTop: 'auto' }}>
            <Button variant="primary">Go to About</Button>
          </RouterLink>
        </div>

        {isAuthenticated && (
          <div style={cardStyle}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: 12, color: 'var(--ds-text-primary)' }}>Dashboard</h2>
            <p style={{ textAlign: 'center', marginBottom: 16, color: 'var(--ds-text-secondary)' }}>
              View your AI-powered cryptocurrency analysis and trading recommendations with real-time market data and insights.
            </p>
            <RouterLink to="/dashboard" style={{ textDecoration: 'none', marginTop: 'auto' }}>
              <Button variant="primary">Go to Dashboard</Button>
            </RouterLink>
          </div>
        )}

        <div style={cardStyle}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: 12, color: 'var(--ds-text-primary)' }}>Design System</h2>
          <p style={{ textAlign: 'center', marginBottom: 16, color: 'var(--ds-text-secondary)' }}>
            Built with a custom design system for consistent, beautiful UI across all portals.
          </p>
          <a href="https://lucide.dev/icons/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', marginTop: 'auto' }}>
            <Button variant="primary">Learn More</Button>
          </a>
        </div>
      </div>

      <div style={{ marginTop: 32, textAlign: 'center' }}>
        <p style={{ fontSize: '0.875rem', color: 'var(--ds-text-secondary)' }}>
          Current Environment: {env.appEnv}
        </p>
        <p style={{ fontSize: '0.875rem', color: 'var(--ds-text-secondary)' }}>
          API URL: {env.apiUrl}
        </p>
      </div>
    </div>
  );
};

export default HomePage;
